import React from 'react';
import {Trash2} from "lucide-react";
import {Button} from "../../../shadcn/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../../shadcn/components/ui/dialog";
import {useTranslation} from "../../../context/Internationalization"


const DeleteConfirmationModal = ({open, onClose, onDelete}) => {
    const {t} = useTranslation()

    return (
        <Dialog open={Boolean(open)} onOpenChange={(next, details) => !next && onClose?.(details?.event)}>
            <DialogContent closeLabel={t('close')}>
                <DialogHeader>
                    <DialogTitle>{t('delete_post')}</DialogTitle>
                    <DialogDescription>
                        {t('delete_post_warning_msg')} {t('delete_activity_confirmation_subtitle')}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={onClose}>{t('close')}</Button>
                    <Button type="button" variant="destructive" onClick={onDelete}>
                        <Trash2 aria-hidden="true" />
                        {t('delete')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
